import { Quote, Star, ArrowLeft, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { Reveal, ChapterTag } from "./Reveal";

export default function Testimonials() {
  const { t, dir } = useLang();
  const reviews = t("testimonials");
  const Arrow = dir === "rtl" ? ArrowLeft : ArrowRight;
  const reviewSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://barqsafe-sa.com/#business",
    name: "برق سيف لحلول الأعمال | Barq Safe Business Solutions",
    url: "https://barqsafe-sa.com",
    telephone: "+966579462600",
    email: "barq.safe.sa@gmail.com",
    address: {
      "@type": "PostalAddress",
      streetAddress: "شارع السويدي العام، حي السويدي، داخل القصر مول",
      addressLocality: "الرياض",
      postalCode: "11564",
      addressCountry: "SA",
    },
    aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: String(reviews.length), bestRating: "5" },
    review: reviews.map((item) => ({
      "@type": "Review",
      author: { "@type": "Person", name: item.n },
      reviewBody: item.q,
      name: item.r,
      reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
    })),
  };
  return (
    <section id="testimonials" data-testid="testimonials-section" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(reviewSchema) }} />
      <Reveal>
        <ChapterTag num="06" label={t("ch_testimonials")} />
        <div className="flex flex-wrap items-end justify-between gap-6">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight">{t("testimonials_title")}</h2>
          <Link to="/success-stories" data-testid="stories-link"
            className="group inline-flex items-center gap-2 text-gold text-sm font-semibold underline-offset-4 hover:underline">
            {t("stories_link")}
            <Arrow size={16} className="transition-transform rtl:group-hover:-translate-x-1 ltr:group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {reviews.map((item, i) => (
          <Reveal key={item.n} delay={i * 0.12}>
            <figure data-testid={`testimonial-card-${i}`}
              className="glass rounded-2xl p-8 h-full flex flex-col transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40">
              <Quote size={28} className="text-gold/60 mb-4" />
              <div className="flex gap-1 mb-5" data-testid={`testimonial-stars-${i}`}>
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={16} className="fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="text-white/75 text-sm md:text-base leading-relaxed flex-1">{item.q}</blockquote>
              <figcaption className="mt-6 pt-5 border-t border-white/10">
                <div className="font-display font-bold">{item.n}</div>
                <div className="text-xs text-gold mt-0.5">{item.r}</div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
